import { type SxProps, type Theme } from '@mui/system';

export const dialogSx: SxProps<Theme> = {
  '& .MuiPaper-root': {
    margin: {
      xs: '6px',
      md: '32px',
    },
    minWidth: {
      xs: '360px',
      lg: '800px',
    },
  },
  '& .MuiDialogContent-root': {
    padding: '12px',
  },
  '& .MuiDialogTitle-root': {
    color: '#006EC2',
    fontSize: '28px',
    fontWeight: 'bold',
    borderBottom: 'solid 2px #ECECEC',
    margin: '0px 30px 30px',
    padding: '34px 0px 15px',
  },
  '& .MuiDialogActions-root': {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '50px',
    '& .MuiButton-root': {
      width: '132px',
      textTransform: 'none',
      fontSize: '18px',
      background: '#006EC2',
      color: '#FFFFFF',
    },
  },
  '& .message': {
    fontSize: '18px',
    color: '#006EC2',
    textAlign: 'center',
    fontWeight: 800,
  },
};
